import React from "react"
import ReactDOM from "react-dom"
import App from "./Components/App/App"
import "../node_modules/font-awesome/css/font-awesome.min.css"

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
)
